import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/selectPage',
    method: 'get',
    params
  })
}
export const exportExcel = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/export/excel',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

export const reportTippler = (data) => {
  return request({
    url: '/api/produce/plc/tippler/report',
    method: 'post',
    data
  })
}

